import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {fetchElement} from './../actions';

class ElementContainer extends React.Component {

  constructor(props) {
    super(props);

    this.fetchIfNeeded = this.fetchIfNeeded.bind(this);
  }

  componentDidMount() {
    this.fetchIfNeeded(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.fetchIfNeeded(nextProps, this.props.elementId);
  }

  fetchIfNeeded(props, oldElementId = null) {
    const {element, elementId, fetchElement} = props;
    if (elementId !== oldElementId && !element.isFetching) {
      fetchElement(elementId);
    }
  }

  render() {
    return (this.props.children);
  }
}

ElementContainer.propTypes = {
  fetchElement: React.PropTypes.func,
  elementId: React.PropTypes.string,
  element: React.PropTypes.object,
  children: React.PropTypes.node,
};

function mapDispatchToProps(dispatch) {
  return {
    fetchElement: bindActionCreators(fetchElement, dispatch)
  };
}

function mapStateToProps(state, ownProps) {
  const {elementId} = ownProps.params;
  let {element} = state;


  return {
    elementId,
    element
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ElementContainer);



/** WEBPACK FOOTER **
 ** ./src/modules/elements/containers/ElementContainer.js
 **/